<p-fieldset legend="Decretos de Nomeação" [toggleable]="true" [collapsed]="true">
  <app-lista-arquivos [miniMode]="true" categoria="portNomeacaoDiretoria"></app-lista-arquivos>
</p-fieldset>
<br><p-fieldset legend="Diplomas" [toggleable]="true" [collapsed]="true">
  <app-lista-arquivos [miniMode]="true" categoria="diplomasDiretoria"></app-lista-arquivos>
</p-fieldset>
<br><p-fieldset legend="Certificados" [toggleable]="true" [collapsed]="true">
  <app-lista-arquivos [miniMode]="true" categoria="certificadosDiretoria"></app-lista-arquivos>
</p-fieldset>